///<reference path="../../../typings/angularjs/angular.d.ts"/>

module ProcessEditor {
    var eventName = 'validate.trigger.frends';

    export function frendsValidateOnTrigger($rootScope: ng.IRootScopeService): ng.IDirective {
        return {
            restrict: "A",
            scope: false,
            require: 'ngModel',
            link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) {
                $rootScope.$on(eventName, (event, args) => {
                    ngModel.$setDirty(); // set the model as dirty so the validation will not short circuit due to the model being pristine
                    ngModel.$validate();
                });
            }
        }
    }

    app.directive("frendsValidateOnTrigger", ["$rootScope", frendsValidateOnTrigger]);

}